import { ActionStatus } from '@common/constants/shared';
import { MetadataAction } from '@common/types/action';
import { get, isEmpty } from 'lodash';
import { ActionResponse } from '../excuteAction';

export const findOneRecord: (
  action: any,
  metadata: MetadataAction
) => Promise<ActionResponse> = async (
  action: any,
  metadata: MetadataAction
) => {
  const { messages } = metadata;

  if (action.status === ActionStatus.ERROR) {
    return {
      status: ActionStatus.FAILED,
      message: get(action, 'error.message'),
    };
  }

  const recordFound = action.response;

  const currentRecordIds = { [recordFound?.databaseId]: recordFound?.id };

  return {
    status: ActionStatus.SUCCESS,
    message: messages['database_find_one_record'],
    recordCreated: recordFound,
    ...(!isEmpty(currentRecordIds) && { currentRecordIds }),
  };
};
